import { WithStyles, withStyles } from "@material-ui/core/styles";
import update from "immutability-helper";
import * as React from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import {
  ISchool,
  ISeasonResponse,
  ISeasonResponsesAndSchoolActive,
  ISport,
  ITemplate,
} from "src/api/types";
import Component from "src/shared/components/Component";
import SeasonsPage from "src/features/director/pages/seasons/seasonsPage/SeasonsPage";
import Sidebar from "src/shared/components/sidebar/Sidebar";
import withAppContext, { IAppContextProps } from "src/shared/components/withAppContext";
import withAxios, { IAxiosProps } from "src/shared/components/withAxios";
import SchoolEditorPage from "./pages/SchoolEditorPage/SchoolEditorPage";
import SchoolsPage from "./pages/SchoolsPage";
import SportsPage from "./pages/SportsPage";
import UploadVideoPage from "./pages/UploadVideoPage";
import TemplateEditorPage from "./pages/template-editor/TemplateEditorPage";
import TemplatesPage from "./pages/TemplatesPage";
import SubscriptionPurchaseList from "./pages/SubscriptionPurchaseList";
import UpdateSubscriptionPlan from "./pages/SubscriptionPurchaseList/updateSubscription";
import UpdateAddonPage from "./pages/SubscriptionPurchaseList/updateAddon";
import admininquire from "./pages/adminInquire/admininquire";
// import AdminStructureDemoPage from "./pages/AdminStructureDemoPage";

const styles = () => ({
  content: {
    padding: 20,
  },
});

type IProps = IAxiosProps &
  IAppContextProps &
  WithStyles<keyof ReturnType<typeof styles>>;

interface IAdminState {
  schools: ISchool[];
  loadingSchools?: true;
  sports: ISport[];
  loadingSports?: true;
  seasons: ISeasonResponse[];
  loadingSeasonsResponse?: true;
  templates: ITemplate[];
  loadingTemplates?: true;
  seasonsSaved?: true;
  seasonsSaving?: true;
  planSelect: any,
  addonSelect: any
}

export default withAppContext(
  withStyles(styles)(
    withAxios(
      class extends Component<IProps, IAdminState> {
        public readonly state = this.buildState({
          schools: [],
          seasons: [],
          seasonsSaved: true,
          sports: [],
          templates: [],
          planSelect: {},
          addonSelect: {}
        });

        public componentDidMount() {
          this.loadSchools();
          this.loadTemplates();
          this.loadSports();
          this.loadSeasons(true);
          // This clears the white action buttons
          this.props.appContext.setTheme({});
        }

        public changePlanUpdate = (item: any) => {
          this.setState({ planSelect: item })

        }
        public render() {
          return (
            <Sidebar isAdmin={true}>
              <Switch>
                <Route exact={true} path="/admin">
                  <Redirect to="/admin/templates" />
                </Route>
                <Route
                  path="/admin/schools/edit/:schoolId"
                  component={this.ParamsSchoolEditorPage}
                />
                <Route
                  path="/admin/schools/edit"
                  component={this.ParamsSchoolEditorPage}
                />
                <Route
                  path="/admin/templates/edit/:templateId"
                  render={this.ParamsTemplateEditorPage}
                />
                <Route
                  path="/admin/templates/edit"
                  component={this.ParamsTemplateEditorPage}
                />
                <Route
                  path="/admin/schools"
                  component={this.ParamsSchoolsPage}
                />
                <Route
                  path="/admin/templates"
                  component={this.ParamsTemplatesPage}
                />
                <Route path="/admin/sports" component={this.ParamsSportsPage} />
                <Route path="/admin/upload-video" component={UploadVideoPage} />
                <Route path="/admin/subscription-page" component={this.ParamsSubscriptionPlan} />
                <Route path="/admin/plan-update" component={this.ParamsUpdateSubscriptionPlan} />
                <Route path="/admin/inquire" component={admininquire} />
                {/* <Route path="/admin/structure-demo" component={AdminStructureDemoPage} /> */}
                <Route path="/admin/addon-update" component={this.ParamsUpdateSubscriptionAddon} />
          


                {/* UploadVideoPage */}
                <Route
                  path="/admin/seasons"
                  component={this.ParamsSeasonsPage}
                />
              </Switch>
            </Sidebar>
          );
        }

        private ParamsTemplateEditorPage = ({
          match,
          history,
        }: RouteComponentProps<{ templateId: string }>) => {
          const parsedTemplateId = parseInt(match.params.templateId, 10);
          return (
            <TemplateEditorPage
              isEditorMode={true}
              templateId={
                isNaN(parsedTemplateId) ? undefined : parsedTemplateId
              }
              history={history}
            />
          );
        };

        private ParamsSchoolEditorPage = ({
          match,
          history,
        }: RouteComponentProps<{ schoolId: string }>) => {
          const parsedSchoolId = parseInt(match.params.schoolId, 10);
          const { appContext } = this.props;
          const { loadingSchools, schools, templates } = this.state;
          return (
            <SchoolEditorPage
              appContext={appContext}
              loadSchools={this.loadSchools}
              loadingSchools={loadingSchools}
              schools={schools}
              schoolId={isNaN(parsedSchoolId) ? undefined : parsedSchoolId}
              history={history}
              templates={templates}
            />
          );
        };

        private ParamsSchoolsPage = () => {
          const { loadingSchools, schools } = this.state;
          return (
            <SchoolsPage
              loadSchools={this.loadSchools}
              loadingSchools={loadingSchools}
              schools={schools}
            />
          );
        };

        private ParamsTemplatesPage = () => {
          const { loadingTemplates, templates } = this.state;
          return (
            <TemplatesPage
              loadTemplates={this.loadTemplates}
              loadingTemplates={loadingTemplates}
              templates={templates}
            />
          );
        };

        private ParamsSportsPage = () => {
          const { loadingSports, sports } = this.state;
          return (
            <SportsPage
              loadSports={this.loadSports}
              setSport={this.setSport}
              loadingSports={loadingSports}
              sports={sports}
            />
          );
        };

        private ParamsSubscriptionPlan = () => {
          const { planSelect, addonSelect } = this.state;
          return (
            <SubscriptionPurchaseList
              selectPlan={(item: any) => { this.changePlanUpdate(item) }}
              planSelect={planSelect}
              selectAddon={(item: any) => { this.setState({ addonSelect: item }) }}
              addonSelect={addonSelect}
            />
          );
        };
        private ParamsUpdateSubscriptionPlan = () => {
          const { planSelect, addonSelect } = this.state;
          return (
            <UpdateSubscriptionPlan
              selectPlan={(item: any) => { this.changePlanUpdate(item) }}
              planSelect={planSelect}
              selectAddon={(item: any) => { this.setState({ addonSelect: item }) }}
              addonSelect={addonSelect}
            />
          );
        };
        private ParamsUpdateSubscriptionAddon = () => {
          const { addonSelect, planSelect } = this.state;
          return (
            <UpdateAddonPage
              selectPlan={(item: any) => { this.changePlanUpdate(item) }}
              planSelect={planSelect}
              selectAddon={(item: any) => { this.setState({ addonSelect: item }) }}
              addonSelect={addonSelect}
            />
          );
        };


        private ParamsSeasonsPage = () => {
          const {
            seasons,
            loadingSeasonsResponse,
            sports,
            seasonsSaved,
            seasonsSaving,
          } = this.state;
          return (
            <SeasonsPage
              saved={seasonsSaved}
              saving={seasonsSaving}
              defaultSeasons={true}
              seasons={seasons}
              loadingSeasonsResponse={loadingSeasonsResponse}
              loadSeasons={this.loadSeasons}
              setSeason={this.setSeason}
              seasonsChange={this.seasonsChange}
              sports={sports}
            />
          );
        };

        private readonly loadSchools = () =>
          void this.runCancellableStatefulAsync(
            this,
            {
              loadingSchools: true,
            },
            {
              loadingSchools: undefined,
            },
            async () => {
              this.setState({
                schools: await this.buildGet<ISchool[]>(this, "school")(),
              });
            },
            () => {
              this.setState({ loadingSchools: undefined });
              window.alert("Error loading schools");
            }
          );

        private readonly loadTemplates = () =>
          void this.runCancellableStatefulAsync(
            this,
            {
              loadingTemplates: true,
            },
            {
              loadingTemplates: undefined,
            },
            async () => {
              this.setState({
                templates: await this.buildGet<ITemplate[]>(this, "template")(),
              });
            },
            () => {
              this.setState({ loadingTemplates: undefined });
              window.alert("Error loading templates");
            }
          );

        private readonly loadSports = () =>
          void this.runCancellableStatefulAsync(
            this,
            {
              loadingSports: true,
            },
            {
              loadingSports: undefined,
            },
            async () => {
              this.setState({
                sports: await this.buildGet<ISport[]>(this, "sport")(),
              });
            },
            () => {
              this.setState({ loadingSports: undefined });
              window.alert("Error loading sports");
            }
          );

        private readonly setSport = (sport: ISport, sportName: string) => {
          this.setState((prevState) =>
            update(prevState, {
              sports: {
                [prevState.sports.indexOf(sport)]: {
                  name: { $set: sportName },
                },
              },
            })
          );
        };

        private readonly setSeason = (
          season: ISeasonResponse,
          seasonName: string,
          startDate: number
        ) => {
          this.setState((prevState) =>
            update(prevState, {
              seasons: {
                [prevState.seasons.indexOf(season)]: {
                  name: { $set: seasonName },
                  startDate: { $set: startDate },
                },
              },
              seasonsSaving: { $set: true },
            })
          );
        };

        private readonly seasonsChange = (seasons: ISeasonResponse[]) => {
          this.setState({
            seasons,
            seasonsSaving: true,
          });
        };

        private readonly loadSeasons = (showLoading?: true) =>
          void this.runCancellableStatefulAsync(
            this,
            {
              loadingSeasonsResponse:
                showLoading !== undefined ? true : undefined,
            },
            {
              loadingSeasonsResponse: undefined,
            },
            async () => {
              if (showLoading === undefined) {
                this.setState({
                  seasonsSaving: true,
                });
              }
              const seasonResponsesAndSchoolActive =
                await this.buildGet<ISeasonResponsesAndSchoolActive>(
                  this,
                  `seasons/${-1}`
                )();
              this.setState({
                seasons: seasonResponsesAndSchoolActive.seasons,
                seasonsSaving: undefined,
              });
            },
            () => {
              this.setState({ seasonsSaved: undefined });
              window.alert("Error loading seasons");
            }
          );
      }
    )
  )
);



// WEBPACK FOOTER //
// ./src/features/admin/AdminPage.tsx